export const calculatePercentage = ({ initial, value, total }) => {
  if (initial) {
    return Math.round(((value - initial) * 100) / (total - initial));
  }

  return Math.round((value * 100) / total);
};
